import { Link, Outlet } from 'react-router-dom';

import { ArrowLeftIcon } from '@radix-ui/react-icons';

import { ROUTES } from '@/shared/config/routes';

export const AuthLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-violet-50 via-white to-purple-50 px-4 sm:px-6 lg:px-8">
      {/* Back to home link — fixed top left */}
      <div className="pt-6 pl-2">
        <Link
          to={ROUTES.HOME}
          className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-violet-600 transition-colors"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          Back to Home
        </Link>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-sm sm:max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
